import './FieldDisplay.css';

/**
 * Read-only labelled value cell used inside `.cfg-field-grid` grids.
 * Extracted from Configuracion.jsx and Facturacion.jsx to eliminate the
 * duplicate local definitions and the cross-import of Configuracion.css.
 *
 * @param {object} props
 * @param {string} props.label       - Plain-text label rendered above the value.
 * @param {React.ReactNode} props.value
 * @param {boolean} [props.mono]     - Render the value in monospace.
 * @param {boolean} [props.muted]    - De-emphasize the value (secondary ink).
 * @param {boolean} [props.fullWidth] - Span all grid columns (`1 / -1`).
 * @param {boolean} [props.ellipsis] - Truncate long values with an ellipsis.
 */
export default function CfgFieldDisplay({
  label,
  value,
  mono,
  muted,
  fullWidth,
  ellipsis,
}) {
  return (
    <div
      className="cfg-field-display"
      style={fullWidth ? { gridColumn: '1 / -1', minWidth: 0 } : undefined}
    >
      <div className="cfg-field-display__label">{label}</div>
      <div
        className={[
          'cfg-field-display__value',
          mono ? 'mono' : '',
          muted ? 'muted' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        style={
          ellipsis
            ? {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }
            : undefined
        }
        title={ellipsis && typeof value === 'string' ? value : undefined}
      >
        {value}
      </div>
    </div>
  );
}
